import { Link } from "../link/Link";

import "./Breadcrumbs.css";

import type { NativeBehavior } from "../link/Link";
import type { ReactNode } from "react";

export interface Breadcrumb {
  href?: string;
  nativeBehavior?: NativeBehavior;
  text: string;
}

export interface BreadcrumbsProps {
  items?: Breadcrumb[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <div className="Breadcrumbs">
      {items
        ?.map<ReactNode>((item) => {
          if (!item.href) {
            return (
              <span key={item.text} className="Breadcrumb">
                {item.text}
              </span>
            );
          }

          return (
            <Link
              key={item.href}
              to={item.href}
              className="Breadcrumb"
              nativeBehavior={item.nativeBehavior}
              // We need to fully-reload the document when
              // navigating to a new page because some pages
              // live outside the context of this Classroom
              // app and cannot be routed to using React
              // Router.
              reloadDocument
            >
              {item.text}
            </Link>
          );
        })
        .reduce((prev, curr) => [
          prev,
          <span key="separator" className="Breadcrumbs__separator">
            {"•"}
          </span>,
          curr,
        ])}
    </div>
  );
}
